module.exports = __webpack_public_path__ + "img/logo-sm.155c6ef4.svg";